import { render } from "./ShippingAddressReportList.vue?vue&type=template&id=3bf22735&scoped=true&ts=true"
import script from "./ShippingAddressReportList.vue?vue&type=script&lang=ts"
export * from "./ShippingAddressReportList.vue?vue&type=script&lang=ts"

import "./ShippingAddressReportList.vue?vue&type=style&index=0&id=3bf22735&scoped=true&lang=css"
import "./ShippingAddressReportList.vue?vue&type=style&index=1&id=3bf22735&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf22735"]])

export default __exports__